import styled from 'styled-components';
import { CALLER_COLORS as C } from './tokens';
import phoneIcon from './icons/phone.svg';
import closeIcon from './icons/close.svg';

type Props = {
  count: number;
  onClose: () => void;
};

// Shared "Caller ID" panel header (Figma node 19:1066). Rendered once at the
// panel level so the title + count + close persist across the CallerV2 tabs.
const CallerPanelHeader = ({ count, onClose }: Props) => {
  return (
    <HeaderBar>
      <Left>
        <IconTint>
          <img src={phoneIcon} alt="" width={20} height={20} />
        </IconTint>
        <Titles>
          <Title>Caller ID</Title>
          <Subtitle>{`${count} incoming call${count === 1 ? '' : 's'}`}</Subtitle>
        </Titles>
      </Left>
      <CloseButton type="button" onClick={onClose} aria-label="Close">
        <img src={closeIcon} alt="" width={20} height={20} />
      </CloseButton>
    </HeaderBar>
  );
};

export default CallerPanelHeader;

const HeaderBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px 19px;
  border-bottom: 1px solid ${C.border};
  background: #fff;
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
`;

const IconTint = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: ${C.iconTintBg};
`;

const Titles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const Title = styled.span`
  color: ${C.navy};
  font-size: 18px;
  font-weight: 700;
`;

const Subtitle = styled.span`
  color: ${C.gray};
  font-size: 12px;
`;

const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border: none;
  border-radius: 10px;
  background: ${C.lightBtnBg};
  cursor: pointer;
  &:active {
    opacity: 0.7;
  }
`;
